import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import useScrollToSection from '../../../../../../../../hooks/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import customiseSectionTitleStyles from '../../../../customiseSectionTitle/customiseSectionTitleStyles';
import ShowIfTranslationExists from '../../../../../../../../../common/components/ShowIfTranslationExists';
import Translation from '../../../../../../../../../common/components/translation/Translation';

export interface ISelectedSectionNameProps {
  label: string;
}
const SelectedSectionName: FC<ISelectedSectionNameProps> = ({ label }) => {
  const styles = customiseSectionTitleStyles();
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <>
      <Typography
        component="p"
        variant="subtitle1"
        className={styles.title}
        data-test={`summary:selected:sectionTitle:${label}`}
      >
        <Translation id={`trans__configurator__customise_page_${label}_section__section_title`} />
        <ShowIfTranslationExists translationKey={`trans__configurator__indicative_numbers__${label}`}>
          <IndicativeNumber
            dataTest={`${label}`}
            displayNumber={<Translation id={`trans__configurator__indicative_numbers__${label}`} />}
            onClick={scrollToDisclaimer}
            className={styles.indicativeNumber}
          />
        </ShowIfTranslationExists>
      </Typography>
    </>
  );
};

export default SelectedSectionName;
